import { WebStorageStateStore, UserManagerSettings } from "oidc-client-ts";
import { logInfo } from "@/loggers";
import { FEATURE_NAMES } from "@/loggers/types";

const hasWindow = typeof window !== "undefined";

const getBaseUri = (path: string = ""): string => {
  if (!hasWindow) {
    return path;
  }
  return `${window.location.protocol}//${window.location.host}${path}`;
};

const authority = import.meta.env.VITE_IAM_BASE_URL;
const redirectUri = getBaseUri();
const postLogoutRedirectUri = getBaseUri("/logged-out");

logInfo(
  FEATURE_NAMES.MVS,
  `IAM Configuration - Authority: ${authority}, Redirect URI: ${redirectUri}, Post-logout URI: ${postLogoutRedirectUri}`
);

const userManagerSettings: UserManagerSettings = {
  authority,
  client_id: "isce",
  redirect_uri: redirectUri,
  response_type: "code",
  scope: "openid profile email roles customer_code.any",
  post_logout_redirect_uri: postLogoutRedirectUri,
  userStore: hasWindow ? new WebStorageStateStore({ store: window.localStorage }) : undefined,
  automaticSilentRenew: true
};

export { userManagerSettings };
